import { Reveal, Stagger, StaggerItem } from "@/components/anim/Reveal";
import CTASection from "@/components/site/CTASection";
import { SERVICES } from "@/data/solutions";

const Services = () => {
  return (
    <div data-testid="page-services">
      <section className="relative pt-24 pb-8 md:pt-32">
        <div className="fs-grid-bg" />
        <div className="fs-container relative">
          <Reveal><div className="fs-eyebrow">Solutions</div></Reveal>
          <Reveal delay={0.1}>
            <h1 className="fs-heading text-4xl md:text-6xl mt-5 max-w-4xl">
              One partner for the entire{" "}
              <span className="fs-gradient-text">enterprise stack.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-[color:var(--text-dim)] max-w-2xl leading-relaxed">
              From carrier-grade WAN to cloud calling and cyber defence — sixteen
              solution lines engineered for reliability, security and scale.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="fs-section pt-8">
        <div className="fs-container">
          <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" stagger={0.04}>
            {SERVICES.map((s) => {
              const Icon = s.icon;
              return (
                <StaggerItem key={s.title}>
                  <div className="fs-card p-6 h-full" data-testid={`services-page-${s.title.replace(/\s+/g, "-").toLowerCase()}`}>
                    <div className="fs-icon-tile"><Icon size={20} /></div>
                    <div className="mt-5 fs-tag">{s.tag}</div>
                    <h3 className="mt-2 text-lg font-semibold">{s.title}</h3>
                    <p className="mt-3 text-sm text-[color:var(--text-dim)] leading-relaxed">{s.desc}</p>
                  </div>
                </StaggerItem>
              );
            })}
          </Stagger>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default Services;
